import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'auto-advanced-offer-set-configuration',
    templateUrl: './offer-set-configuration.component.html',
    styleUrls: ['./offer-set-configuration.component.scss'],
    standalone: false
})
export class AdvancedAdConfigurationComponent implements OnInit, OnChanges {
  @Input() data: any | null = null;
  @Output() dataEmitter = new EventEmitter<UntypedFormGroup>();
  form: UntypedFormGroup;
  disclosureSetOptions: { label: string; value: number }[] = [];

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      accountOfferSetRefresh: [false],
      customTitleDisplayOverride: [false],
      newOfferSetCustomTitleOverrideText: [''],
      usedOfferSetCustomTitleOverrideText: [''],
      cpoOfferSetCustomTitleOverrideText: [''],
      minimizeDisclaimer: [false],
      newMainCtaText: [''],
      usedMainCtaText: [''],
      disclosureSet: [0],
      enhancedDisclosure: [false],
      ncsUseLatestSpecialsUx: [false],
      sharedOfferSetsEnabled: [false],
      enhancedDisclosureEnabled: [false]
    });

    this.dataEmitter.emit(this.form);
    this.patchFromInput(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.patchFromInput(changes['data'].currentValue);
    }
  }

  private patchFromInput(offerSetAdvancedSettings: any): void {
    if (offerSetAdvancedSettings && this.form) {
      // Build options
      this.disclosureSetOptions = this.buildDisclosureSetOptions(offerSetAdvancedSettings);

      // Selected disclosure set
      let selectedDisclosureSet = 0;
      if (Number.isFinite(offerSetAdvancedSettings.disclosureSet)) {
        selectedDisclosureSet = Number(offerSetAdvancedSettings.disclosureSet);
      }

      this.form.patchValue(
        {
          accountOfferSetRefresh: !!offerSetAdvancedSettings.accountOfferSetRefresh,
          customTitleDisplayOverride: !!offerSetAdvancedSettings.customTitleDisplayOverride,
          newOfferSetCustomTitleOverrideText: offerSetAdvancedSettings.newOfferSetCustomTitleOverrideText || '',
          usedOfferSetCustomTitleOverrideText: offerSetAdvancedSettings.usedOfferSetCustomTitleOverrideText || '',
          cpoOfferSetCustomTitleOverrideText: offerSetAdvancedSettings.cpoOfferSetCustomTitleOverrideText || '',
          minimizeDisclaimer: !!offerSetAdvancedSettings.minimizeDisclaimer,
          newMainCtaText: offerSetAdvancedSettings.newMainCtaText || '',
          usedMainCtaText: offerSetAdvancedSettings.usedMainCtaText || '',
          disclosureSet: selectedDisclosureSet,
          enhancedDisclosure: !!offerSetAdvancedSettings.enhancedDisclosure,
          sharedOfferSetsEnabled: !!offerSetAdvancedSettings.sharedOfferSetsEnabled,
        },
        { emitEvent: false }
      );

      this.form.markAsPristine();
    }
  }

  private buildDisclosureSetOptions(offerSetAdvancedSettings: any): { label: string; value: number }[] {
    let options: { label: string; value: number }[] = [];
    const sets = offerSetAdvancedSettings?.disclosureSets;

    if (Array.isArray(sets)) {
      options = sets
        .filter((disclosureSet: any) => disclosureSet && Number.isFinite(disclosureSet.id))
        .map((disclosureSet: any) => {
          let label = String(disclosureSet.id);
          if (disclosureSet?.name?.length) {
            label = disclosureSet.name;
          }
          return { label, value: Number(disclosureSet.id) };
        });
    }

    return options;
  }

}
